;(function() {
  'use strict'

  angular.module('core.autofill', [])
})()
